// @flow

import type { Action, Crop, Pixels } from './reducer';

const toggleScrollLock = () => document.querySelector('html').classList.toggle('u-overflow-hidden');

export function zoomImage(zoom: number): Action {
  return {
    type: 'ZOOM',
    zoom,
  };
}

export function showCrop(image: string): Action {
  toggleScrollLock();
  return {
    type: 'SHOW_CROP',
    image,
  };
}

export function cropImage(crop: Crop): Action {
  return {
    type: 'CROP',
    crop,
  };
}

export function completeCropping(pixels: Pixels): Action {
  return {
    type: 'COMPLETE',
    pixels,
  };
}

export function renderImage(image: string): Action {
  toggleScrollLock();
  return {
    type: 'RENDER',
    image,
  };
}

export function closeModal(): Action {
  toggleScrollLock();
  return {
    type: 'CLOSE',
  };
}

export function openModal(): Action {
  toggleScrollLock();
  return {
    type: 'OPEN',
  };
}
